
<template>
  <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isBarangActive" position-right>
    <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
      <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header bg-primary">
        <h5 class="text-white">Tambah Barang</h5>
        <feather-icon :icon="$vs.rtl ? 'XIcon' : 'XIcon'" @click="barangAddClose" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
      </div>

      <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6 mt-base" :settings="settings" :key="$vs.rtl">

        <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
          
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input label="Barang" v-model="dataBarang" class="w-full" name="item-barang" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('item-barang')">{{ errors.first('item-barang') }}</span>
            </div>
          </div>

          <div class="vx-row mb-8">
            <div class="vx-col w-1/3">
              <vs-input label="Harga (rupiah)" v-model="dataHarga" class="pr-2 w-full" name="item-harga" v-validate="'required'" 
              v-currency="{
              currency: null, 
              locale: 'de',
              precision:0,
              distractionFree:false
              }"/>

              <span class="text-danger text-sm" v-show="errors.has('item-harga')">{{ errors.first('item-harga') }}</span>
            </div>

            <div class="vx-col w-1/3 flex">
              <vs-select
                label="Satuan"
                v-model="dataSatuan"
                v-validate="'required'"
                class="w-full"
                >
                  <vs-select-item value="0" text="Tidak ada"/>
                  <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSatuan"/>
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('satuan')">{{ errors.first('satuan') }}</span>
              <vs-button class="mt-6" @click.stop="tambahSatuan=true" >+</vs-button>
            </div>

            <div class="vx-col w-1/3 flex" v-if="Tranksaksi === 'sewa'">
              <vs-select
                label="Waktu"
                v-model="dataWaktu"
                v-validate="'required'"
                class="w-full"
                >
                  <vs-select-item value="0" text="Tidak ada"/>
                  <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listWaktu"/>
              </vs-select>
              <vs-button size="small" class="mt-6" @click.stop="tambahWaktu=true" >+</vs-button>
            </div>
          </div>

          <vs-divider class="mt-base">Satuan Pembelian</vs-divider>

          <vs-row>
            <vs-col vs-align="center" vs-w="4">
              <vs-select
                label="Satuan Pembelian"
                v-model="dataSatuanPembelian"
                v-validate="'required'"
                class="mt-4 w-full"
                @change="pilihSatuanPembelian"
                @click.prevent="changePilihSatuanPembelian"
                >
                  <vs-select-item value="0" text="Tidak ada"/>
                  <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSatuan"/>
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('satuan')">{{ errors.first('satuan') }}</span>
            </vs-col>

            <vs-col vs-align="center" vs-w="2">
              <vs-button class="py-3 mt-10" @click.stop="tambahSatuan=true" >+</vs-button>
            </vs-col>

            <vs-col vs-align="center" vs-w="6">

              <vs-input label="Harga Pembelian (rupiah)" v-model="dataHargaPembelian" class="pr-2 mt-4 w-full" name="item-harga" v-validate="'required'" 
              v-currency="{
              currency: null, 
              locale: 'de',
              precision:0,
              distractionFree:false
              }"/>

              <span class="text-danger text-sm" v-show="errors.has('item-harga')">{{ errors.first('item-harga') }}</span>
            </vs-col>
          </vs-row>
          
          <vs-divider class="mt-base">Konversi Satuan</vs-divider>

          <vs-row>
            <vs-col vs-align="center" vs-w="6" class="flex pr-2 items-center">
              <vs-input label="Pembelian" v-model="dataKonversiCons" class="pr-2 mt-4 w-full" disabled/>
              {{dataNamaSatuanPembelian}}
            </vs-col>

            <vs-col vs-align="center" vs-w="6" class="flex items-center">
              <vs-input label="Bahan" v-model="dataKonversiVar" class="pr-2 mt-4 w-full" name="item-konversi" v-validate="'required'"/>
              {{dataNamaSatuan}}
            </vs-col>
            <span class="text-danger text-sm" v-show="errors.has('item-konversi')">{{ errors.first('item-konversi') }}</span>
          </vs-row>

          <div class="vx-row mt-6">
          <div class="vx-col w-1/2">
            <div class="flex flex-wrap items-center">
              <vs-button class="" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
            </div>
          </div>
          <div class="vx-col w-1/2">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button type="border" color="danger" @click="isBarangActiveLocal = false">Cancel</vs-button>
            </div>
          </div>
          </div>

        </div>
      </component>
    </div>

    <vs-prompt
      color="success"
      title="Tambah Satuan"
      @accept="satuanAdd"
      @close="close"
      :active.sync="tambahSatuan"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Satuan" data-vv-name="addsatuan" name="addsatuan" v-validate="'required'" v-model="addSatuan"/>
        <span class="text-danger text-sm" v-show="errors.has('addsatuan')">{{ errors.first('addsatuan') }}</span>
       </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      title="Tambah Waktu"
      @accept="waktuAdd"
      @close="close"
      :active.sync="tambahWaktu"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Waktu" data-vv-name="addwaktu" name="addwaktu" v-validate="'required'" v-model="addWaktu"/>
        <span class="text-danger text-sm" v-show="errors.has('addwaktu')">{{ errors.first('addwaktu') }}</span>
       </div>
    </vs-prompt>

  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'

export default {
  props: {
    isBarangActive: {
      type: Boolean,
      required: true
    },
    Taxonomy: {
      type: String,
      required: true
    },
    Tranksaksi: {
      type: String,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    
  },
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {

      dataId: null,
      dataBarang: null,
      dataGroup: 0,
      dataParent: 0,
      dataHarga: null,
      dataSatuan: 0,
      dataWaktu: 0,

      dataNamaSatuan: null,
      dataHargaPembelian: null,
      dataSatuanPembelian: 0,
      dataNamaSatuanPembelian: null,
      dataKonversiCons: 1,
      dataKonversiVar: 0,
      changeSatuan: false,
      changeSatuanPembelian: false,
      
      listSatuan: [],
      listWaktu: [],

      addSatuan: null,
      tambahSatuan: false,

      addWaktu: null,
      tambahWaktu: false,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      }
    }
  },
  watch: {
    isBarangActive (val) {
      
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }

      this.axios.get('/term-list-sort/satuan/ASC', configs)
      .then((response) => {
        let {data} = response.data
        this.listSatuan = data
      })
      .catch((error) => {
        let data = error.data
        this.listSatuan = data
      })

      this.axios.get('/term-list/waktu', configs)
      .then((response) => {
        let {data} = response.data
        this.listWaktu = data
      })
      .catch((error) => {
        let data = error.data
        this.listWaktu = data
      })

      if (!val) return
      this.initValues()
      this.$validator.reset()
      if (this.Taxonomy === '') {
        this.$vs.notify({
          title: 'Error',
          text: 'Pilih pembelian',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        this.$emit('closeBarang')
      }
    }
  },
  computed: {
    isBarangActiveLocal: {
      get () {
        return this.isBarangActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeBarang')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataBarang && this.dataHarga && this.dataSatuan && this.dataHargaPembelian && this.dataSatuanPembelian && this.dataKonversiVar
    },
    validateSatuan() {
      return !this.errors.any() && this.addSatuan !== null
    },
    validateWaktu() {
      return !this.errors.any() && this.addWaktu !== null
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  mounted(){
  },
  beforeDestroy () {
  },
  methods: {
    changePilihSatuan () {
      this.changeSatuan = true
    },
    changePilihSatuanPembelian () {
      this.changeSatuanPembelian = true
    },
    pilihSatuan() {
      if (this.changeSatuan) {
        const ItemIndex = this.listSatuan.find((satuan) => satuan.id == this.dataSatuan)
        this.dataNamaSatuan = ItemIndex.name
      }
    },
    pilihSatuanPembelian() {
      if (this.changeSatuanPembelian) {
        const ItemIndex = this.listSatuan.find((satuan) => satuan.id == this.dataSatuanPembelian)
        this.dataNamaSatuanPembelian = ItemIndex.name
      }
    },
    initValues () {
      this.dataId = null
      this.dataBarang = null
      this.dataGroup = 0
      this.dataParent = 0
      this.dataHarga = null
      this.dataSatuan = 0
      this.dataWaktu = 0
      this.dataNamaSatuan = null
      this.dataHargaPembelian = 0
      this.dataSatuanPembelian = 0
      this.dataNamaSatuanPembelian = null
      this.dataKonversiVar = 0
    },
    close() {
      this.$emit('closed', false)
    },
    barangAddClose() {
      this.$emit('closeBarang')
    },
    satuanAdd() {

      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addSatuan,
        term_group: 0,
        parent: 0,

        taxonomy: 'satuan'
      }

      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listSatuan = []
        this.addSatuan = null
        this.loadSatuan()

        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Satuan telah bertambah',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response

        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    },
    loadSatuan () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/satuan', configs)
      .then((response) => {
        let {data} = response.data
        this.listSatuan = data
      })
      .catch((error) => {
        let data = error.data
        this.listSatuan = data
      })
    },
    waktuAdd() {

      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addWaktu,
        term_group: 0,
        parent: 0,

        taxonomy: 'waktu'
      }

      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listWaktu = []
        this.addWaktu = null
        this.loadWaktu()

        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Waktu telah bertambah',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response

        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    },
    loadWaktu () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/waktu', configs)
      .then((response) => {
        let {data} = response.data
        this.listWaktu = data
      })
      .catch((error) => {
        let data = error.data
        this.listWaktu = data
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let obj = Object
          if (this.Tranksaksi === 'sewa') {
            obj = {
              id: this.dataId,
              name: this.dataBarang,
              term_group: this.dataGroup,
              parent: this.dataParent,

              meta : {
                harga: this.dataHarga.split('.').join(""),
                satuan: this.dataSatuan,
                waktu: this.dataWaktu,
                harga_pembelian: this.dataHargaPembelian.split('.').join(""),
                satuan_pembelian: this.dataSatuanPembelian,
                konversi: this.dataKonversiVar
              },

              taxonomy: this.Taxonomy
            }
          } else {
            obj = {
              id: this.dataId,
              name: this.dataBarang,
              term_group: this.dataGroup,
              parent: this.dataParent,

              meta : {
                harga: this.dataHarga.split('.').join(""),
                satuan: this.dataSatuan,
                harga_pembelian: this.dataHargaPembelian.split('.').join(""),
                satuan_pembelian: this.dataSatuanPembelian,
                konversi: this.dataKonversiVar
              },

              taxonomy: this.Taxonomy
            }
          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('barang/updateBarang', obj)
          } else {
            delete obj.id
            this.$store.dispatch('barang/addBarang', obj)
          }
          this.$emit('closeBarang')
          this.initValues()
        }
      })
    }
  }
}
</script>
